import http from '../jslibs/axios/http';

//业务管理 业务员列表
export const salesmanlist = data => (http.get('/v1/cms/Salesman', data));

//业务管理 新增业务员
export const addSalesman = data => (http.post('/v1/cms/Salesman', data));

//业务管理 编辑业务员
export const editSalesman = data=> (http.put(`/v1/cms/Salesman/${data.uuid}`, data));

//业务管理 删除业务员
export const deleteSalesman = uuid => (http.delete(`/v1/cms/Salesman/${uuid}`));

//业务管理 业务员详情
export const salesmanDetail = uuid => (http.get(`/v1/cms/Salesman/${uuid}`));